import React from "react";
import { Outlet } from "react-router-dom";
import TopNavbar from "../Nav/TopNavbar";
import Footer from "../Sections/Footer";
import styled from "styled-components";

export default function Layout() {
  return (
    <PageContainer>
      <ContentWrapper>
        <TopNavbar />
        <MainContent>
          <Outlet />
        </MainContent>
      </ContentWrapper>
      <Footer />
    </PageContainer>
  );
}

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const ContentWrapper = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
`;